import api from '@/libs/axiosInstance';

export interface ConnectShopifyDto {
  shop: string;
}

export interface ConnectShopifyResponse {
  integration: {
    id: string;
    platform: string;
    status: string;
    brandId: string;
  };
}

export interface GetShopifyInstallUrlResponse {
  installUrl: string;
  message: string;
}

export interface Integration {
  id: string;
  platform: string;
  status: string;
  brandId: string;
  metadata?: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

/**
 * Get Shopify install URL for compliant OAuth flow.
 * This replaces the manual shop entry flow.
 */
export const getShopifyInstallUrl = async (): Promise<GetShopifyInstallUrlResponse> => {
  const response = await api.get('/dashboard/integrations/shopify/install-url');
  return response.data.data;
};

/**
 * @deprecated Use getShopifyInstallUrl instead for compliant OAuth flow.
 * This endpoint violates Shopify App Store policy by requesting manual shop entry.
 */
export const connectShopify = async (data: ConnectShopifyDto): Promise<ConnectShopifyResponse> => {
  const response = await api.post('/dashboard/integrations/shopify/start', data);
  return response.data;
};

export const listIntegrations = async (): Promise<Integration[]> => {
  const response = await api.get('/dashboard/integrations');
  return response.data.data || [];
};

export const deleteIntegration = async (id: string): Promise<void> => {
  await api.delete(`/dashboard/integrations/${id}`);
};
